import Layout from './Layout';
import connect from './connect';

export default connect(Layout);



// WEBPACK FOOTER //
// ./src/app/Layout/index.js